import { Trans, useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { Dialog, LinkButton, Text } from '~/components';
import { AnchorTargets, SearchParamKeys } from '~/constants/url';
import { routes } from '~/providers/RouterProvider/router.routes';
import { qs } from '~/utils/searchParams';

export const EnableCommunityProfileDialog = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation(['community']);

  return (
    <Dialog.Body>
      <Dialog.Header title={t('community:enableCommunityProfileDialog.title')} />

      <Text>
        <Trans i18nKey="community:enableCommunityProfileDialog.description" />
      </Text>

      <Dialog.Actions>
        <LinkButton
          to={{
            pathname: routes.settingsProfile,
            hash: AnchorTargets.SETTINGS_PROFILE_COMMUNITY,
            search: qs({ [SearchParamKeys.REDIRECT_PATH]: pathname }),
          }}
        >
          {t('community:enableCommunityProfileDialog.actions.goToSettings')}
        </LinkButton>
      </Dialog.Actions>
    </Dialog.Body>
  );
};
